import {
  editableEvent,
  normalizeSelectorShortcut,
  selectorShortcutConflicts,
} from './selector-shortcut';

/** Opens and closes the canvas overview. A bare key: it applies only where nothing is typed. */
export const DEFAULT_CANVAS_OVERVIEW_SHORTCUT = 'Tab';
export const canvasOverviewCommandPrefix = 'editor:edgeless:canvas-overview:';

export const normalizeCanvasOverviewShortcut = (value: string) =>
  normalizeSelectorShortcut(value, true);

export const canvasOverviewShortcutConflicts = (
  value: string,
  nativeBindings: Iterable<string> = []
) =>
  selectorShortcutConflicts(value, nativeBindings, canvasOverviewCommandPrefix);

/**
 * Whether a key press may toggle the overview: not a held or composing key, and not one typed
 * into a text.
 */
export const admitsCanvasOverviewShortcut = (event: KeyboardEvent) =>
  !event.repeat &&
  !event.isComposing &&
  event.keyCode !== 229 &&
  !editableEvent(event);
